<div class="staticPage">
    <h1 class="blueColor">{{ 'suggest_song_header' | translate }}</h1>
    <div class="gradientDivider"></div>

    <div class="suggestContainer">
        <div class="contact-form">
            <form [formGroup]="songForm" (submit)="submitForm()">

                <span class="ui-float-label">
                    <input maxlength="600" type="text" formControlName="name" pInputText style="width:100%">
                    <label for="float-input">{{'suggest_song_name' | translate}}</label>
                </span>

                <div style="height:20px;"></div>

                <span class="ui-float-label">
                    <input  maxlength="600"  type="text" formControlName="url" pInputText style="width:100%">
                    <label for="float-input">{{'suggest_song_url' | translate}}</label>
                </span>

                <div style="height:20px;"></div>

                <span class="ui-float-label">
                    <input  maxlength="600"  type="email" formControlName="email" pInputText style="width:100%">
                    <label for="float-input">{{'suggest_song_email' | translate}}</label>
                </span>



                <div style="height:20px;"></div>
                <re-captcha #captchaRef="reCaptcha" (resolved)="resolved($event)" siteKey="6LejErUaAAAAANvR4nU9PFog2pZWE8pB1A4Exu8h"></re-captcha>
                <!--  <span class="ui-float-label" style="text-align: left;color:#333333">
                    {{'suggest_song_file' | translate}}
                    <div style="height:5px;"></div>
                    <p-fileUpload chooseLabel="{{'suggest_song_choose' | translate}}"  mode="basic" name="demo[]" url="./upload.php"  ></p-fileUpload>
                </span>

                <div style="height:20px;"></div>

                <span class="ui-float-label">
                    <textarea rows="5" [style]="{'width':'100%'}" pInputTextarea formControlName="text"></textarea>
                    <label for="float-input">{{'suggest_song_text' | translate}}</label>
                </span>-->

                <div style="height:20px;"></div>

                <div class="ui-sm-6 ui-md-5 ui-lg-3 ui-xl-2" style="padding-left: 0;">
                    <button *ngIf="!loading" pButton type="submit" label="{{'suggest_song_send' | translate}}"
                        [disabled]="songForm.invalid" class="ui-button-info" style="width: 100%;"></button>
                    <app-loader *ngIf="loading"></app-loader>
                </div>
            </form>
        </div>
    </div>

</div>